var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.color
    ? _c("div", { staticClass: "c-solid-color-picker-wrapper" }, [
        _c("div", { staticClass: "left-panel" }, [
          _c(
            "div",
            { staticClass: "c-saturation-wrapper" },
            [
              _c(_setup.SaturationBoard, {
                on: { change: _setup.onColorChange },
                model: {
                  value: _setup.color,
                  callback: function ($$v) {
                    _setup.color = $$v
                  },
                  expression: "color",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "c-picker-controls" }, [
            _c("div", { staticClass: "c-sliders" }, [
              _c(
                "div",
                { staticClass: "c-hue-wrapper" },
                [
                  _c(_setup.HueSlider, {
                    attrs: { colors: _setup.color },
                    on: { change: _setup.onColorChange },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "c-alpha-wrapper" },
                [
                  _c(_setup.AlphaSlider, {
                    attrs: { colors: _setup.color },
                    on: { change: _setup.onColorChange },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "c-color-preview",
              style: { "background-color": _setup.rbgPreview },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right-panel" },
          [
            _vm._l(_setup.inputModeSet, function (_, key, idx) {
              return _c(_setup.CInput, {
                key: `input-${key}-${idx}`,
                staticClass: "mb-2",
                attrs: {
                  label: key.toUpperCase(),
                  type: "number",
                  step: ".01",
                  "input-size": "sm",
                  inline: "",
                },
                on: {
                  input: function ($event) {
                    return _setup.onColorChange({
                      [_vm.mode]: _setup.inputModeSet,
                    })
                  },
                },
                model: {
                  value: _setup.inputModeSet[key],
                  callback: function ($$v) {
                    _vm.$set(_setup.inputModeSet, key, $$v)
                  },
                  expression: "inputModeSet[key]",
                },
              })
            }),
            _vm._v(" "),
            _c(_setup.CInput, {
              attrs: {
                inline: "",
                label: "A",
                type: "number",
                min: 0,
                max: 1,
                "input-size": "sm",
              },
              on: {
                input: function ($event) {
                  _setup.onColorChange({
                    hsl: _setup.color.hsl,
                    a: Number($event),
                  })
                },
              },
              model: {
                value: _setup.inputModel.alpha,
                callback: function ($$v) {
                  _vm.$set(_setup.inputModel, "alpha", $$v)
                },
                expression: "inputModel.alpha",
              },
            }),
            _vm._v(" "),
            _vm.mode !== "cmyk"
              ? _c(_setup.CInput, {
                  staticClass: "mt-2",
                  attrs: { inline: "", label: "#", "input-size": "sm" },
                  on: {
                    blur: function ($event) {
                      return _setup.onColorChange({ hex: `${$event}` })
                    },
                    enter: function ($event) {
                      return _setup.onColorChange({ hex: `${$event}` })
                    },
                  },
                  model: {
                    value: _setup.inputModel.hex,
                    callback: function ($$v) {
                      _vm.$set(_setup.inputModel, "hex", $$v)
                    },
                    expression: "inputModel.hex",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-auto ml-auto mb-2" },
              [
                _c(_setup.CButton, {
                  attrs: { size: "icon", icon: ["fas", "eye-dropper"] },
                  on: { click: _setup.openEyedropper },
                }),
                _vm._v(" "),
                _vm.allowReset
                  ? _c(_setup.CButton, {
                      attrs: { variant: "secondary", text: _vm.resetText },
                      on: { click: _setup.onReset },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _vm._t("footer"),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }